export default "__VITE_ASSET__D5o0Y4Xr__"